import { IDlsVersionMeta } from './define-versions';

/**
 * Resolves the version a component should render: the explicit `v` prop wins
 * when it matches one of the component's versions; anything else (including a
 * Storybook-injected version this component doesn't have) falls back to
 * `meta.default` (required while a `previous` version exists), then
 * `meta.current`.
 */
export const resolveVersion = (meta: IDlsVersionMeta, v?: string): string =>
  v != null && (v === meta.current || v === meta.previous)
    ? v
    : meta.default ?? meta.current;
